module.exports = __webpack_public_path__ + "img/right-arrow.5017710a.svg";